import React from 'react/addons';
import {Respond, At} from 'react-respond-to';
import {reverse} from 'ofs/urls';
import DesktopBreadbar from './_DesktopBreadbar';
import MobileBreadbar from './_MobileBreadbar';
import {gettext} from 'ofs/i18n';

const slugs = [
  'book-capture-details', 
  'book-capture-guests', 
  'book-capture-arrival',
  'book-capture-departure',
  'book-capture-stay-details',
];

const messages = {
  'book-capture-details': gettext("Your details"),
  'book-capture-guests': gettext("Additional guests"),
  'book-capture-arrival': gettext("Arriving"),
  'book-capture-departure': gettext("Departing"),
  'book-capture-stay-details': gettext("Stay details"),
};

const ResponsiveBreadbar = React.createClass({
  render() {
    const links = {};
    slugs.forEach((slug) => {
      links[slug] = {
        url: reverse(slug, {'code': this.props.bookingRef}),
        title: messages[slug],
      };
    });

    return (
      <div> 
        <Respond to='min-width'>
          <At default><MobileBreadbar links={links} currentPage={this.props.currentPage} /></At>
          <At value='641px'><DesktopBreadbar links={links} currentPage={this.props.currentPage} /></At>
        </Respond>
      </div>
    );
  }
}); 

export default ResponsiveBreadbar;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/ResponsiveBreadbar.jsx
 **/